import Player from '@vimeo/player';

/**
 * Usage:
 *
 * Step 1: Somewhere in JS...
 *   import Alpine from "alpinejs";
 *   import video from "./video";
 *   Alpine.data('video', video);
 *   Alpine.start();
 *
 * Step 2: Somewhere in markup...
 *   <div x-data="vimeoPlayer('url-to-video', { quality : 'auto' })" />
 *
 * @param src
 * @param options
 * @returns {{play(): void, init(): void, iframeCont: null, src: string, pause(): void}}
 */
export default (src = '', options = {}) => ({
  src: src,
  iframeCont: null,

  init() {
    this.$nextTick(() => {
      var opts = {
        url: src,
        height: this.$el.clientHeight,
        width: this.$el.clientWidth,

        allowfullscreen: 0,
        autopause: 0,
        autoplay: 0,
        controls: 0,
        loop: 1,
        muted: 1,
        playsinline: 1,
        responsive: 0,
        quality: 'auto',

        ...options,
      };

      // console.log(opts);

      if (!this.iframeCont) {
        var play = new Player(this.$el, opts);
        this.iframeCont = play.element;
      }
    });
  },

  play() {
    this.$nextTick(() => {
      var player = new Player(this.$el);
      player.play().then(function() {
      }).catch(e => console.log(e));
    });
  },

  pause() {
    this.$nextTick(() => {
      var player = new Player(this.$el);
      player.pause().then(function() {
      }).catch(e => console.log(e));
    });
  }
});
